import StatsSection from './StatsSection';
import React from 'react';

const StatsSectionWithProps = (props: any) => {
  return (
    <StatsSection
      statItems={props.statItems}
      theme={props.theme}
      enablePaddingTop={props.enablePaddingTop ?? true}
      enablePaddingBottom={props.enablePaddingBottom ?? true}
    />
  );
};

export default StatsSectionWithProps;
